<template>
  <div class="fixed_page" id="blurry">
    <div class="get-started">
      <div class="home-main">
        <div class="fixed_page">
          <div class="fixed_page">
            <div class="winners_upd_box">
              <h1>{{ getTranslations.visitor_visitor_header_winners }}</h1>
              <img src="/static/images/icon-Winners.png">
              <p>{{ getTranslations.visitor_visitor_winner_discover }}
                <span>{{ getTranslations.visitor_visitor_winner_lucky }}</span>
                {{ getTranslations.visitor_visitor_winner_far }}</p>
            </div>
            <div class="winners_upd_grand" v-if="grandWin.length >0 && hasValue(0)">
              <h1>{{ getTranslations.visitor_visitor_winner_grand }}</h1>
              <div v-for="(winner, index) in grandWin" :key="index">
                <div v-if=" index < 5 || showMoreGrand">
                  <div class="rank_row">
                    <img :src="winner.userDTO.avatar">
                    <div class="upd_prize_col">
                      <h2 v-if="winnersShowMsisdn">{{ winner.userDTO.msisdn }}</h2>
                      <h2 v-else>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }}</h2>
                      <p>{{ winner.prizeDTO.headline }}</p>
                    </div>
                    <div class="vertical_line_rank"></div>
                    <div class="rank_points">
                      <div class="rank_col">
                        <p>{{ getTranslations.visitor_visitor_winner_date }}</p>
                        <label>{{ normalizeDate(winner.localDateTime) }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rank_border"></div>
              </div>
              <div class="load_more_btn rank" v-if="moreWinnersButton">
                <button class="load-more btn2 btn2--std btn2--small" @click="displayMore(1)">···</button>
              </div>
              <div class="upd_prize_bottom">
                <p>{{ getTranslations.visitor_visitor_winner_the }} <span>{{
                    getTranslations.visitor_visitor_winner_next
                  }}</span>{{
                    getTranslations.visitor_visitor_winner_announced
                  }}<span>{{ getTranslations.visitor_visitor_winner_next_date }}</span></p>
              </div>
              <div class="last_upt">
                <p>{{ getTranslations.visitor_visitor_winner_update }}
                  <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
              </div>
            </div>
            <div v-else-if="hasValue(0)" class="winners_upd_grand">
              <h1>{{ getTranslations.visitor_visitor_winner_grand }}</h1>
              <p>{{ getTranslations.visitor_visitor_winner_yet }}<span>{{
                  getTranslations.visitor_visitor_winner_next
                }}</span> {{ getTranslations.visitor_visitor_winner_announced }}
                <span>{{ getTranslations.visitor_visitor_winner_next_date }}</span></p>

              <div class="last_upt">
                <p>{{ getTranslations.visitor_visitor_winner_update }}
                  <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
              </div>
            </div>

            <div>
              <!-- start_circle -->
              <div class="circle_background">

                <div class="leaderboard_rank_box winners_upd_monthly" v-if="monthlyWin.length > 0 && hasValue(1)">

                  <h1>{{ getTranslations.visitor_visitor_winner_monthly }}</h1>
                  <div v-for="(winner, index) in monthlyWin" :key="index">
                    <div v-if=" index < 5 || showMoreMonthly">
                      <div class="rank_row">
                        <img :src="winner.userDTO.avatar">
                        <div class="upd_prize_col">
                          <h2 v-if="winnersShowMsisdn">{{ winner.userDTO.msisdn }}</h2>
                          <h2 v-else>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }}</h2>
                          <p>{{ winner.prizeDTO.headline }}</p>
                        </div>
                        <div class="vertical_line_rank"></div>
                        <div class="rank_points">
                          <div class="rank_col">
                            <p>{{ getTranslations.visitor_visitor_winner_date }}</p>
                            <label>{{ normalizeDate(winner.localDateTime) }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="rank_border"></div>
                    </div>
                  </div>
                  <div class="load_more_btn rank" v-if="moreWinnersMButton">
                    <button class="load-more btn2 btn2--std btn2--small" @click="displayMore(2)">···</button>
                  </div>
                  <div class="upd_prize_bottom">
                    <p>{{ getTranslations.visitor_visitor_winner_the }}
                      <span>{{ getTranslations.visitor_visitor_winner_next }}</span>
                      {{ getTranslations.visitor_visitor_winner_announced }}
                      <span>{{ getTranslations.visitor_visitor_winner_next_date }}</span></p>
                  </div>
                  <div class="last_upt">
                    <p>{{ getTranslations.visitor_visitor_winner_update }}
                      <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
                  </div>
                </div>
                <div v-else-if="hasValue(1)" class="winners_upd_grand">
                  <h1>{{ getTranslations.visitor_visitor_winner_monthly }}</h1>
                  <p>{{
                      getTranslations.visitor_visitor_winner_yet
                    }}<span>{{ getTranslations.visitor_visitor_winner_next }}</span>
                    {{ getTranslations.visitor_visitor_winner_announced }}
                    <span>{{ getTranslations.visitor_visitor_winner_next_date }}</span></p>

                  <div class="last_upt">
                    <p>{{ getTranslations.visitor_visitor_winner_update }}
                      <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span></p>
                  </div>
                </div>
                <div class="leaderboard_rank_box winners_upd_instant" v-if="instantWin.length > 0 && hasValue(2)">
                  <h1>{{ getTranslations.visitor_visitor_winner_instant }}</h1>
                  <div v-for="(winner, index) in instantWin" :key="index">
                    <div v-if=" index < 5 || showMoreInstant">
                      <div class="rank_row">

                        <img :src="winner.userDTO.avatar">
                        <div class="upd_prize_col">
                          <h2 v-if="winnersShowMsisdn">{{ winner.userDTO.msisdn }}</h2>
                          <h2 v-else>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }}</h2>
                          <p>{{ winner.prizeDTO.headline }}</p>
                        </div>
                        <div class="vertical_line_rank"></div>
                        <div class="rank_points">
                          <div class="rank_col">
                            <p>{{ getTranslations.visitor_visitor_winner_date }}</p>
                            <label>{{ normalizeDate(winner.localDateTime) }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="rank_border"></div>
                    </div>
                  </div>
                  <div class="load_more_btn rank" v-if="moreWinnersIButton">
                    <button class="load-more btn2 btn2--std btn2--small" @click="displayMore(3)">···</button>
                  </div>
                  <div class="upd_prize_bottom">
                    <p>
                      {{ getTranslations.visitor_visitor_winner_the }}
                      <span>{{ getTranslations.visitor_visitor_winner_next }}</span>
                      {{ getTranslations.visitor_visitor_winner_announced }}
                      <span>{{ getTranslations.visitor_visitor_winner_next_date }}</span>
                    </p>
                  </div>
                  <div class="last_upt">
                    <p>
                      {{ getTranslations.visitor_visitor_winner_update }}
                      <span>{{ getTranslations.visitor_visitor_winner_last_date }}</span>
                    </p>
                  </div>
                </div>
                <div v-else-if="hasValue(2)" class="winners_upd_grand">
                  <h1>{{ getTranslations.visitor_visitor_winner_instant }}</h1>
                  <p>
                    {{ getTranslations.visitor_visitor_winner_yet }}
                    <span>{{ getTranslations.visitor_visitor_winner_next }}</span>
                    {{ getTranslations.visitor_visitor_winner_announced }}
                    <span>{{ getTranslations.visitor_visitor_winner_next_date }}</span>
                  </p>

                  <div class="last_upt">
                    <p>
                      {{ getTranslations.visitor_visitor_winner_update }}<span>{{ getTranslations.visitor_visitor_winner_last_date }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'winners',
  data () {
    return {
      countTestimonials: 0,
      showMoreGrand: false,
      showMoreMonthly: false,
      showMoreInstant: false,
      winnersKeys: ['visitor_visitor_winner_grand', 'visitor_visitor_winner_monthly', 'visitor_visitor_winner_instant'],
    };
  },
  beforeRouteLeave (to, from, next) {
    /* eslint-disable */
    console.log('==> inside component\'s beforeRouteLeave: Winners');
    console.log(`from.path: ${ from.path }`);
    console.log(`to.path: ${ to.path }`);
    this.storeVisitorWinners(this.getLocale);
    next();
    /* eslint-enable */
  },
  created () {
  },
  methods: {
    ...mapActions('profile', [
      'storeVisitorWinners',
    ]),
    ...mapMutations('profile', [
      'setMoreWinnersButton',
    ]),
    hasValue (i) {
      if (this.getTranslations[this.winnersKeys[i]] != null) {
        return true;
      }
      return false;
    },
    displayMore (i) {
      if (i === 1) {
        if (this.moreWinnersButton) {
          this.showMoreGrand = !this.showMoreGrand;
        }
      }
      if (i === 2) {
        if (this.moreWinnersMButton) {
          this.showMoreMonthly = !this.showMoreMonthly;
        }
      }
      if (i === 3) {
        if (this.moreWinnersIButton) {
          this.showMoreInstant = !this.showMoreInstant;
        }
      }
    },
    normalizeDate (date) {
      moment.locale(localStorage.getItem('locale'));
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    ...mapState('profile', [
      'monthlyButton',
      'grandButton',
      'weeklyButton',
      'moreWinnersButton',
      'moreWinnersMButton',
      'moreWinnersIButton',
      'totalWinners',
      'instantWin',
      'grandWin',
      'monthlyWin',
      'allWinners',
    ]),
    ...mapState('common', [
      'userDetails',
      'winnersShowMsisdn'
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationTestimonial',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Winners.vue